import React from 'react';
import { Box } from '@mui/material';
import { GeneralInfo } from './general-info';
import { ContractAppendix } from './contract-appendix';

const ContractForm = ({
  selectedContract,
  getContractDetail,
  initData,
  isReadOnly = false,
  clientCareHistoryItem,
  clientInformationDetail,
  onCloseModal,
}) => {
  return (
    <Box>
      <GeneralInfo
        clientCareHistoryItem={clientCareHistoryItem}
        clientInformationDetail={clientInformationDetail}
        selectedContract={selectedContract}
        getContractDetail={getContractDetail}
        initData={initData}
        isReadOnly={isReadOnly}
        onCloseModal={onCloseModal}
      />

      {/* Phụ lục hợp đồng */}
      <ContractAppendix
        isReadOnly={isReadOnly}
        selectedContract={selectedContract}
        getContractDetail={getContractDetail}
      />
    </Box>
  );
};

export { ContractForm };
